<template>
    <b-card no-body>
        <b-modal id="edit-firm-info" size="lg" :title="[firm.Name,'Firma Bilgileri'].join(' - ')" no-close-on-esc no-close-on-backdrop>
            <firm-create-or-update-info v-model="firm" :editing="infoUpdating"></firm-create-or-update-info>
            <template #modal-footer><v-executer :loading="infoUpdating" text="Güncelle" :action="updateFirmInfo"></v-executer></template>
        </b-modal>

        <b-modal body-class="p-0" id="edit-firm-location" size="xl" :title="[firm.Name,'Firma Lokasyonları'].join(' - ')" hide-footer no-close-on-esc no-close-on-backdrop>
            <firm-location-table :firm="firm" v-on:refresh="refresh"></firm-location-table>
        </b-modal>

		<b-modal body-class="p-0" id="edit-firm-contact" size="xl" :title="[firm.Name,'Firma İletişim Bilgileri'].join(' - ')" hide-footer no-close-on-esc no-close-on-backdrop>
            <firm-contact-table :firm="firm" v-on:refresh="refresh"></firm-contact-table>
        </b-modal>

        <b-modal body-class="p-50" id="show-on-map" size="lg" title="Firma Lokasyonu" hide-footer no-close-on-esc no-close-on-backdrop>
            <firm-location-on-map v-model="currentLocation"></firm-location-on-map>
        </b-modal>

        <v-table    ref="table"
                    :items-provider="provider"
                    :fields="fields"
                    pagination="server"
                    :buttons="buttons"
                    button-td-class="align-top px-50 py-50"
                    :settings="false"
                    search
                    :add-callback="createNew">
                        
                    </v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import FirmOperationsApi from '@/api/firm-operations'
import FirmCreateOrUpdateInfo from '@/views/firm-operations/firm/components/FirmCreateOrUpdateInfo'
import FirmLocationTable from '@/views/firm-operations/firm/components/FirmLocationTable'
import FirmContactTable from '@/views/firm-operations/firm/components/FirmContactTable'
import Additional from '@/utilities/additional'
import FirmLocationOnMap from './components/FirmLocationOnMap.vue'

export default {
    components:{
        BCard,
        FirmContactTable,
        FirmLocationTable,
        FirmCreateOrUpdateInfo,
        FirmLocationOnMap
    },
    data(){
        return{
            fields:[
                {
                    name:'Ana Firma',
                    key:'MainFirmName',
                    tdClass:'text-nowrap align-top px-50 py-1',
                    thClass:'w-30'
                },
                {
                    name:"Logo",
                    key:"Logo",
                    img:true,
                    thClass:'w-10'
                },
                {
                    name:'Firma',
                    key:'Name',
                    tdClass:'text-nowrap align-top px-50 py-1',
                    thClass:'w-30'
                },
                {
                    name:'Vergi/TC No',
                    key:'TaxNumber',
                    tdClass:'text-nowrap align-top px-50 py-1',
                    thClass:'w-20'
                },
                {
                    name:'Lokasyon Adedi',
                    key:'LocationsCount',
                    tdClass:'text-nowrap align-top px-50 py-1',
                    thClass:'w-10'
                }
            ],
            buttons:[
                { text:"Firma Bilgilerini Düzenle",key:"edit-firm-info",icon:"InfoIcon",variant:"primary",action:this.editInfo},
				{ text:"Firma Lokasyonlarını Düzenle",key:"edit-firm-location",icon:"MapPinIcon",variant:"success",action:this.editLocation},
				{ text:"Firma İletişim Bilgilerini Düzenle",key:"edit-firm-contact",icon:"PhoneIcon",variant:"warning",action:this.editContact},
				{ text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete},
            ],
            firm:{
				Id:null,
				Name:null,
				FirmShortName:null,
				ParentFirmId:null,
				SectorTypeIds:[],
				TaxAdministrationId:null,
				TaxNumber:null,
				Logo:null,
				IsOwnFirm:false,
                IsCompany:true,
            },
            infoUpdating:false,
            currentLocation:{
                LocationName:null,
                LocationType:null,
                LocationTypeId:null,
                Country:null,
                CountryId:null,
                Province:null,
                ProvinceId:null,
                District:null,
                DistrictId:null,
                Neighborhood:null,
                NeighborhoodId:null,
                BuildingNumber:null,
                DoorNumber:null,
                Xcoordinate:null,
                Ycoordinate:null,
                Address:null,
                PostalCode:null,
                PostalAddress:null,
                Floor:null
            }
        }
    },
    methods:{
        provider(data){
            return FirmOperationsApi.DataTable(data) 
        },
        refresh(){
            this.$refs.table.refresh()
        },
        editInfo(item){
			this.clearForm()
			this.$refs.table.rowLoading(true)
			FirmOperationsApi.Get(item.Id).then(res=>{
				if(res.data.Success){
					this.firm.Id = res.data.Data.Id
					this.firm.Name = res.data.Data.Name
					this.firm.FirmShortName = res.data.Data.FirmShortName
					this.firm.ParentFirmId = res.data.Data.ParentFirmId
					this.firm.SectorTypeIds = res.data.Data.SectorTypeIds
					this.firm.TaxAdministrationId = res.data.Data.TaxAdministrationId
					this.firm.TaxNumber = res.data.Data.TaxNumber
					this.firm.Logo = res.data.Data.Logo
					this.firm.IsOwnFirm = res.data.Data.IsOwnFirm
					this.firm.IsCompany = res.data.Data.IsCompany
                    this.firm.FirmRole = res.data.Data.FirmRole
					this.$showModal('edit-firm-info')
				}
				this.$refs.table.rowLoading(false)
			}).catch(err=>{
				this.$refs.table.rowLoading(false)
			})
		},
        editLocation(item){
			this.clearForm()
			this.firm.Id = item.Id
			this.firm.Name = item.Name
			this.$showModal('edit-firm-location')
		},
		editContact(item){
			this.clearForm()
			this.firm.Id = item.Id
			this.firm.Name = item.Name
			this.$showModal('edit-firm-contact')
		},
		filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
        },
        async updateFirmInfo(){
			this.infoUpdating = true
			let formData = await Additional.ToFormData(this.firm,["Logo"])
			FirmOperationsApi.InfoUpdate(formData).then(res=>{
				this.$result(res)
				if(res.data.Success){
					this.$hideModal('edit-firm-info')
					this.$refs.table.refresh()
				}
				this.infoUpdating = false
			}).catch(err=>{
				this.infoUpdating = false
				this.$result(null,err)
			})
		},
		clearForm(){
			this.infoUpdating = false
			this.firm.Id = null
			this.firm.Name = null
			this.firm.FirmShortName = null
			this.firm.SectorTypeIds = []
			this.firm.TaxAdministrationId = null
			this.firm.TaxNumber = null
			this.firm.Logo = null
			this.firm.IsOwnFirm = null
		},
        clearCurrentLocation(){
            this.currentLocation.LocationName = null
            this.currentLocation.LocationType = null
            this.currentLocation.LocationTypeId = null
            this.currentLocation.Country = null
            this.currentLocation.CountryId = null
            this.currentLocation.Province = null
            this.currentLocation.ProvinceId = null
            this.currentLocation.District = null
            this.currentLocation.DistrictId = null
            this.currentLocation.Neighborhood = null
            this.currentLocation.NeighborhoodId = null
            this.currentLocation.BuildingNumber = null
            this.currentLocation.DoorNumber = null
            this.currentLocation.Xcoordinate = null
            this.currentLocation.Ycoordinate = null
            this.currentLocation.Address = null
            this.currentLocation.PostalCode = null
            this.currentLocation.Floor = null
            this.currentLocation.PostalAddress=null
        },
        showOnMap(location){
            this.clearCurrentLocation()
            this.currentLocation.LocationName = location.LocationName || null
            this.currentLocation.LocationType = location.LocationType || null
            this.currentLocation.LocationTypeId = location.LocationTypeId || null
            this.currentLocation.Country = location.Country || null
            this.currentLocation.CountryId = location.CountryId || null
            this.currentLocation.Province = location.Province || null
            this.currentLocation.ProvinceId = location.ProvinceId || null
            this.currentLocation.District = location.District || null
            this.currentLocation.DistrictId = location.DistrictId || null
            this.currentLocation.Neighborhood = location.Neighborhood || null
            this.currentLocation.NeighborhoodId = location.NeighborhoodId || null
            this.currentLocation.BuildingNumber = location.BuildingNumber || null
            this.currentLocation.DoorNumber = location.DoorNumber || null
            this.currentLocation.Xcoordinate = location.Xcoordinate || null
            this.currentLocation.Ycoordinate = location.Ycoordinate || null
            this.currentLocation.Address = location.Address || null
            this.currentLocation.PostalCode = location.PostalCode || null
            this.currentLocation.Floor = location.Floor || null
            this.currentLocation.PostalAddress=location.PostalAddress||null
            this.$showModal('show-on-map')
        },
		createNew(){
			this.$router.push({name:'firm-create'})
		},
        delete(item){
			this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} firmasını silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    FirmOperationsApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
		},
    }
}
</script>

<style>
.dark-layout .text-primary{
    color: white !important;
}

.dark-layout .bg-light-primary{
    color: white !important;
}

.white-table{
    background-color: white;
}
.dark-layout .white-table{
    background-color: #283046;
}
[dir] .table-hover tbody tr:hover{
    background-color: transparent !important;
}
</style>